import { render } from "./TablaProfesionalesDisponibles.vue?vue&type=template&id=66463c56&ts=true"
import script from "./TablaProfesionalesDisponibles.vue?vue&type=script&lang=ts"
export * from "./TablaProfesionalesDisponibles.vue?vue&type=script&lang=ts"

import "./TablaProfesionalesDisponibles.vue?vue&type=style&index=0&id=66463c56&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__